<template>
  <div>
    <highcharts
      ref="highchart"
      class="chart"
      :options="chartOptions"
      :updateArgs="updateArgs"
    ></highcharts>
    <div
      v-if="noData"
      class="md-empty-state md-table-empty-state md-theme-default"
    >
      <div class="md-empty-state-container">
        <strong class="md-empty-state-label">No Data Found</strong>
        <p class="md-empty-state-description">{{ noDataMsg }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      noData: false,
      updateArgs: [true, true, { duration: 0 }],
      chartOptions: {
        credits: {
          enabled: false // Do not show the credits label which defaults to say "Highcharts".
        },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            }
          }
        },
        series: [
          {
            colorByPoint: true,
            data: []
          }
        ]
      }
    };
  },
  props: {
    title: {
      type: String
    },
    seriesName: {
      type: String
    },
    noDataMsg: {
      type: String
    }
  },
  mounted() {
    var me = this;
    this.$refs.highchart.chart.showLoading();
    this.$refs.highchart.chart.setTitle({
      text: me.title
    });
    this.chartOptions.series[0].name = this.seriesName;
  },
  methods: {
    bootstrap: function(dataSeries, drilldown, drilldown2) {
      if (!dataSeries || !dataSeries.length) {
        this.noData = true;
      } else {
        this.noData = false;
      }

      this.chartOptions.series[0].data = dataSeries;
      if (drilldown && drilldown.length) {
        this.chartOptions.drilldown = { series: drilldown };
      }
      if (drilldown2 && drilldown2.length) {
        drilldown2.forEach(element => {
          this.chartOptions.drilldown.series.push(element);
        });
      }
      this.$refs.highchart.chart.hideLoading();
    }
  }
};
</script>
<style lang="scss" scoped>
.md-empty-state {
  position: relative;
  top: -250px;
}
.md-empty-state-label {
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
}
</style>
